<app-solo-sheet-view
  [target]="target()"
  [entry]="entry()"
  [prize]="prize()"
  [rule]="rule()"
  [hasSecondaryCurrency]="hasSecondaryCurrency()"
  [selectedIndex]="selectedIndex()"
  [lastIndex]="lastIndex()"
  [singleStake]="singleStake()"
  [sliderMax]="sliderMax()"
  [sliderValue]="sliderValue()"
  [progressPercent]="progressPercent()"
  [stops]="stops()"
  [quoteFailed]="quoteFailed()"
  [quotePercent]="quotePercent()"
  [quoteSeconds]="quoteSeconds()"
  [showRules]="showRules()"
  [paying]="paying()"
  [playDisabled]="playDisabled()"
  [lightning]="!!lightning()"
  [showInvoiceActions]="showInvoiceActions()"
  [showQR]="showQR()"
  [selectedInvoice]="selectedInvoice()"
  [invoicePending]="invoicePending()"
  [payDisabled]="payDisabled()"
  [waiting]="!!waiting()"
  [invoiceCancelled]="invoiceCancelled()"
  (closeClickedEvent)="onCloseClick()"
  (rulesClickedEvent)="onRulesClick()"
  (stepClickedEvent)="onStep($event)"
  (stakeSelectedEvent)="onStakeSelected($event)"
  (copyClickedEvent)="onCopyClick()"
  (payClickedEvent)="onPayClick()"
  (playClickedEvent)="onPlayClick()"
/>
